import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, firstValueFrom, of, tap } from 'rxjs';
import { User } from '../models/user.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user: User = undefined;
  changeCreditsObservable: Subject<void> = new Subject<void>();

  constructor(
    private readonly httpClient: HttpClient,
    private readonly translateService: TranslateService
  ) {
  }

  findUsers(): Promise<any> {
    const headers = new HttpHeaders().set('x-access-token', this.user.token);
    return firstValueFrom(this.httpClient.get(`${environment.api_server_url}/api/users`, {headers}));
  }

  resolve(): Observable<any> {
    return this.loginRefresh(localStorage.getItem('login-token')).pipe(
      tap((res) => {
        //res.token = this.user.token;
        const jwtData = res.token.split('.')[1]
        const decodedJwtJsonData = window.atob(jwtData)
        const decodedJwtData = JSON.parse(decodedJwtJsonData)
        this.user = new User(res);

        //this.user.subscription_level = decodedJwtData.subscription_level;
        //this.user.expiration_date = decodedJwtData.expiration_date;
        const lang = this.user.language || localStorage.getItem('lang') || 'en';
        this.translateService.use(lang);
    }));
  }

  login(email, password): Observable<any> {
    return this.httpClient.post(`${environment.api_server_url}/api/auth/signin`, {
      email: email,
      password: password
    });
  }

  resetPassword(email): Observable<any> {
    console.log(email)
    return of();
  }

  loginRefresh(token: string): Observable<any> {
    const headers = new HttpHeaders().set('x-access-token', this.user.token);
    return this.httpClient.post(`${environment.api_server_url}/api/auth/signin-refresh`, {
      token
    }, {headers});
  }

  logout(): void {
    localStorage.removeItem('login-token');
    this.user = undefined;
  }

  updateUser(user: User): Observable<any> {
    const body = {
      user: {
        name: user.name,
        surname: user.surname,
        language: user.language,
        avatar: user.avatar,
        tourStep: user.tourStep,
        residence: user.residence,
        postal_code: user.postal_code,
        city: user.city,
        province: user.province,
        nationality: user.nationality,
        nif: user.nif,
        id: user.id
      }
    };
    return this.httpClient.put(`${environment.api_server_url}/api/user`, body);
  }

  updateUserTour(user: User): Observable<any> {
    const body = {
      user: {
        tourStep: user.tourStep,
        id: user.id
      }
    };
    return this.httpClient.put(`${environment.api_server_url}/api/user`, body);
  }

  getUsers(limit: number, offset: number, sortField: string, sortOrder: number, filters: any): Promise<any> {
      const headers = new HttpHeaders().set('x-access-token', this.user.token);
      return firstValueFrom(this.httpClient.get(`${environment.api_server_url}/api/users?limit=${limit}&offset=${offset}&sortField=${sortField}&sortOrder=${sortOrder}&filters=${JSON.stringify(filters)}`, { headers }));
  }

  sendMail(subject: string, body: string, users: any[]): Promise<any> {
      const headers = new HttpHeaders().set('x-access-token', this.user.token);
      return firstValueFrom(this.httpClient.post(`${environment.api_server_url}/api/send-users-mail`, { subject, body, userIds: users.map((user) => user.id) }, { headers }));
  }

}
